// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

import { MapControls } from './MapControls';
import type { MapControlsModelType } from './MapControls';

export type GeocodingPreferencesEnum = 'HIGH' | 'MEDIUM' | 'LOW';

export type GeocodingPreferencesModelType = {
    precision: GeocodingPreferencesEnum
};

export type TeamSettingsModelType = {
    clientId: string,
    teamId: string,
    activeTaskProfileId: string,
    color: string,
    currency: string,
    geocodingPreferences: GeocodingPreferencesModelType,
    mapControls: MapControlsModelType
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class TeamSettings extends ImmutableModel {
    static fromJS(json: TeamSettingsModelType): TeamSettings {
        const state: Object = Object.assign({}, json);
        state.geocodingPreferences = GeocodingPreferences.fromJS(
            state.geocodingPreferences
        );
        state.mapControls = MapControls.fromJS(state.mapControls);
        return new this(Immutable.Map(state));
    }

    toJS(): TeamSettingsModelType {
        return {
            clientId: this.clientId,
            teamId: this.teamId,
            activeTaskProfileId: this.activeTaskProfileId,
            color: this.color,
            currency: this.currency,
            geocodingPreferences: this.geocodingPreferences.toJS(),
            mapControls: this.mapControls.toJS()
        };
    }

    get clientId(): string {
        return this._state.get('clientId');
    }

    setClientId(clientId: string): this {
        return this.clone(this._state.set('clientId', clientId));
    }

    get teamId(): string {
        return this._state.get('teamId');
    }

    setTeamId(teamId: string): this {
        return this.clone(this._state.set('teamId', teamId));
    }

    get activeTaskProfileId(): string {
        return this._state.get('activeTaskProfileId');
    }

    setActiveTaskProfileId(activeTaskProfileId: string): this {
        return this.clone(
            this._state.set('activeTaskProfileId', activeTaskProfileId)
        );
    }

    get color(): string {
        return this._state.get('color');
    }

    setColor(color: string): this {
        return this.clone(this._state.set('color', color));
    }

    get currency(): string {
        return this._state.get('currency');
    }

    setCurrency(currency: string): this {
        return this.clone(this._state.set('currency', currency));
    }

    get geocodingPreferences(): GeocodingPreferences {
        return this._state.get('geocodingPreferences');
    }

    setGeocodingPreferences(geocodingPreferences: GeocodingPreferences): this {
        return this.clone(
            this._state.set('geocodingPreferences', geocodingPreferences)
        );
    }

    get mapControls(): MapControls {
        return this._state.get('mapControls');
    }

    setMapControls(mapControls: MapControls): this {
        return this.clone(this._state.set('mapControls', mapControls));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class GeocodingPreferences extends ImmutableModel {
    static fromJS(json: GeocodingPreferencesModelType): GeocodingPreferences {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): GeocodingPreferencesModelType {
        return {
            precision: this.precision
        };
    }

    get precision(): GeocodingPreferencesEnum {
        return this._state.get('precision');
    }

    setPrecision(precision: GeocodingPreferencesEnum): this {
        return this.clone(this._state.set('precision', precision));
    }
}
